import { Button } from "primereact/button";
import React, { Component, Fragment } from "react";
import $ from 'jquery'

class WriteMissingWordsContainerUI extends Component {

    componentDidMount = () => {
        window.x(this.txt)

        $('.fillActivityInput').on('change', (e) => {
            this.handleChange($(e.target).attr('data-index'), $(e.target).val())
        })
    }

    componentDidUpdate = () => {
        window.x(this.txt)

        $('.fillActivityInput').on('change', (e) => {
            this.handleChange($(e.target).attr('data-index'), $(e.target).val())
        })
    }

    render() {

        let { activity, quizViewer } = this.props;
        let { WriteMissingWordsContainerModel } = activity
        //let { selectedStyle } = WriteMissingWordsContainerModel
        //let uiStyle = JSON.parse(JSON.stringify(selectedStyle))
        return (
            <Fragment>
                <div  >
                    {/* style={selectedStyle[0].style} className={selectedStyle[0].class} */}
                    <div ref={(el) => (this.txt = el)}                    >
                        {/* className={uiStyle[1].class} style={uiStyle[1].style} */}
                        {this.replaceToInput()}
                    </div>
                </div>
            </Fragment>
        )
    }

    handlePrevStyle = () => {
        let { activity, quizViewer } = this.props

        activity.WriteMissingWordsContainerModel.prevStyle()
        quizViewer.setState({})

    }

    handleNextStyle = () => {
        let { activity, quizViewer } = this.props

        activity.WriteMissingWordsContainerModel.nextStyle()
        quizViewer.setState({})

    }
    replaceToInput() {
        let { activity, quizViewer } = this.props;
        let { paragraph } = activity.WriteMissingWordsContainerModel
        let { quizViwerModel } = quizViewer.state;
        let regexTocheck = "\\[(\\s*[0-9]+\\s*,*\\s*)*\\]";//regex for [0] or [1] or [2] etc.
        let regexDots = "[.]{3,}"// regex for finding . (dots) equals to or more than 3 dots 
        //let uneditedparagraph = paragraph
        let dots = [...paragraph.matchAll(new RegExp(regexDots, "g"))];
        if (dots.length > 0)
            paragraph = paragraph.replace(dots[0][0], "[0]")
        else {
            regexDots = "[…](.)*"// regex for finding  (dots but special character - that have been enetered by the user) equals to or more than 3 dots
            dots = [...paragraph.matchAll(new RegExp(regexDots, "g"))];
            if (dots.length > 0)
                paragraph = paragraph.replace(dots[0][0], "[0]")
        }
        let formatArray = [...paragraph.matchAll(new RegExp(regexTocheck, "g"))];
        let html = ''
        let paragraphSlices = paragraph

        formatArray.forEach((element, index) => {
            let color = quizViwerModel.reviewMode ? activity.WriteMissingWordsContainerModel.getReviewColor(index) : "black";
            let answerSolved = activity.WriteMissingWordsContainerModel.answerList[index].solvedAnswer
            let parts = paragraphSlices.split(element[0])
            paragraphSlices = parts[1]
           
            //html += uneditedparagraph
            html += parts[0]
            if (quizViwerModel.reviewMode)
                html += ('<input type="text" data-index=' + index + ' class="fillActivityInput" style="text-align: center;outline: none;border: 0px;border-bottom: dotted 1px;  border-color: ' + color + ';color: ' + color + '" value="' + answerSolved + '" disabled="disabled"/>')
            else
                html += ('<input type="text" data-index=' + index + ' class="fillActivityInput" style="text-align: center;outline: none;border: 0px;border-bottom: dotted 1px;  border-color: ' + color + ';color: ' + color + '" value="' + answerSolved + '" />')

        })
        html += paragraphSlices;

        return (
            <Fragment>
                <div dangerouslySetInnerHTML={{ __html: html }}></div>
            </Fragment>
        )

    }
    handleChange = (txtIndex, answerValue) => {

        let { activity, quizViewer } = this.props;
        let { answerList } = activity.WriteMissingWordsContainerModel
        answerList[txtIndex].solvedAnswer = answerValue

    }
}
export default WriteMissingWordsContainerUI